import React, { useContext, useState, useEffect } from 'react';
import QRCode from 'react-qr-code';
import { PageContext } from 'src/context/PageContext';
import styles from './LiveHeader.module.scss';

export function LiveJoinQR() {
  const { urlParams } = useContext(PageContext);
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(
      `${window?.location?.origin}/${urlParams?.organization}/${urlParams?.locale}/live/${
        urlParams?.uuid
      }/${encodeURIComponent(urlParams?.sessionId || '')}/${
        urlParams?.preview ? 'preview' : encodeURIComponent(urlParams?.version || '')
      }${urlParams?.preview && urlParams?.code ? `?code=${urlParams?.code}` : ''}`,
    );
  }, [
    urlParams?.locale,
    urlParams?.organization,
    urlParams?.preview,
    urlParams?.sessionId,
    urlParams?.uuid,
    urlParams?.version,
    urlParams?.code,
  ]);

  if (!url) {
    return null;
  }

  return (
    <div className={styles.liveJoinQR}>
      <QRCode value={url} size={128} />
    </div>
  );
}
